import {Component, forwardRef} from '@angular/core';
import {DictionariesService} from "../../../service";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {ViewDictionaryBase} from "../view-dictionary-base";
import {PageFil} from "../../../../../../api/build";

@Component({
  selector: 'app-dict-qref-fil',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefFilViewComponent),
    multi: true
  }],
  template: `
    <div class="mb-3 col-3 pl-0 pr-0">
      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="rnbn"
                         name="namef"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="['namef','rnbn']"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.namef }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          {{ item.namef }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>
    </div>
  `
})
export class QrefFilViewComponent extends ViewDictionaryBase<PageFil> {
  getDictionary = this.dictSrv.getQrefFilList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
